export default "__VITE_ASSET__QDj92V3k__"